/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '@brochington/ecstatic';
import { Components } from 'editor/components';
import MapboxCanvasSource from 'editor/components/map/MapboxCanvasSource';
import MapboxMap from 'editor/components/map/MapboxMap';
import mapboxgl from 'mapbox-gl';

export const manageCanvasSourceComponents = [MapboxMap, MapboxCanvasSource];

export function manageCanvasSource(args: SystemFuncArgs<Components>): void {
  const { entity, components } = args;
  const mapComp = components.get(MapboxMap);
  const sourceComp = components.get(MapboxCanvasSource);

  if (!mapComp.map) return;

  const existingCanvasSource = mapComp.map.getSource(sourceComp.id);

  if (entity.state === 'destroying') {
    if (sourceComp.added && existingCanvasSource) {
      mapComp.map.removeSource(sourceComp.id);
    }

    return;
  }
  mapComp.map.on('styledata', () => {
    if (!sourceComp.added) {
      if (!existingCanvasSource) {
        mapComp?.map?.addSource(sourceComp.id, sourceComp.tracked.source);
      }
      sourceComp.added = true;
    } else if (
      sourceComp.updatedFields.size > 0 &&
      mapComp.styleState.is('loaded')
    ) {
      const source = mapComp?.map?.getSource(
        sourceComp.id
      ) as mapboxgl.CanvasSource;
      source?.setCoordinates(sourceComp.tracked.source.coordinates);
      sourceComp.updatedFields.clear();
    }
  });
}
